import { useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import toast from 'react-hot-toast';

const CheckoutForm = ({ savedCards, isDarkMode, payResponse, clientSecret }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [loading, setLoading] = useState(false);

    // Theme colors
    const colors = {
        card: isDarkMode ? '#1e1e1e' : '#ffffff',
        text: isDarkMode ? '#e0e0e0' : '#333333',
        subtext: isDarkMode ? '#a0a0a0' : '#666666',
        border: isDarkMode ? '#333333' : '#e0e0e0'
    };

    const cardIcons = [
        { name: 'Visa', src: 'https://img.icons8.com/color/48/visa.png' },
        { name: 'Mastercard', src: 'https://img.icons8.com/color/48/mastercard.png' },
        { name: 'Amex', src: 'https://img.icons8.com/color/48/amex.png' },
        { name: 'Discover', src: 'https://img.icons8.com/color/48/discover.png' },
        { name: 'Diners Club', src: 'https://img.icons8.com/color/48/diners-club.png' },
        { name: 'JCB', src: 'https://img.icons8.com/color/48/jcb.png' },
        { name: 'China UnionPay', src: 'https://img.icons8.com/color/48/unionpay.png' }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) {
            toast.error("Stripe Not Loaded !! Please logout and Login")
            return
        }
        setLoading(true);
        let result;
        if (selectedCardId) {
            // Use saved card
            result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: selectedCardId
            });
        } else {
            const cardElement = elements.getElement(CardElement);
            result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: cardElement,
                },
            });
        }
        setLoading(false);
        if (result.error) {
            toast.error(result.error.message)
        } else if (result.paymentIntent.status === 'succeeded') {
            payResponse({
                type: "Success",
                title: "Payment Success",
                message: "Your payment is being processed and will be reflected shortly in your event. Thank you for your patience!"
            });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {savedCards.length > 0 && (
                <>
                    {savedCards.map((pm) => (
                        <div className="mb-4 p-4 border rounded-lg flex justify-between items-center" style={{ borderColor: colors.border }}>
                            <div className="flex items-center gap-3">
                                <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
                                    <input
                                        type="radio"
                                        name="savedCard"
                                        value={pm?.id}
                                        onChange={() => setSelectedCardId(pm?.id)}
                                        checked={selectedCardId?.id === pm?.id}
                                    />
                                </div>
                                <div className="flex items-center gap-2">
                                    <div className="w-8">
                                        <img src={cardIcons?.find((ci) => ci.name?.toLowerCase() == pm?.card?.brand?.toLowerCase())?.src} />
                                    </div>
                                    <div>
                                        <p className="text-sm" style={{ color: colors.text }}>{pm?.card?.brand}</p>
                                        <p className="text-xs" style={{ color: colors.subtext }}>**** **** **** {pm?.card?.last4}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <label className="block my-2">
                        <input
                            type="radio"
                            name="card"
                            value="new"
                            checked={selectedCardId === null}
                            onChange={() => setSelectedCardId(null)}
                        />
                        <span className={`m-2 font-semibold ${isDarkMode?"text-white": "text-black"}`}>Use a new card</span>
                    </label>
                </>
            )}

            {(savedCards.length === 0 || selectedCardId === null) && (
                <div className="border p-4 rounded">
                    <CardElement options={{ 
                        hidePostalCode: true,
                        style: {
                            base: {
                                fontSize: '16px',
                                color: isDarkMode ? '#ffffff' : '#32325d',
                                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                '::placeholder': { color: isDarkMode ? '#666' : '#bbb', },
                            },
                            invalid: {
                                color: '#fa755a',
                                iconColor: '#fa755a',
                            }
                        }
                    }} />
                </div>
            )}
            <div className='text-center'>
                <button
                    type="submit"
                    disabled={loading}
                    className="bg-blue-600 text-white w-[250px] py-2 rounded-full mt-4">
                    {loading ? 'Processing...' : 'Pay Now'}
                </button>
            </div>
        </form>
    );
};

export default CheckoutForm;


// import React, { useState } from 'react';
// import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
// import toast from 'react-hot-toast';

// const CheckoutForm = ({ clientSecret, payResponse, isDarkMode }) => {
//     const stripe = useStripe();
//     const elements = useElements();
//     const [loading, setLoading] = useState(false);

//     const CARD_ELEMENT_OPTIONS = {
//         style: {
//             base: {
//                 fontSize: '16px',
//                 color: isDarkMode ? '#ffffff' : '#32325d',
//                 fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
//                 '::placeholder': { color: isDarkMode ? '#666' : '#bbb', },
//             },
//             invalid: {
//                 color: '#fa755a',
//                 iconColor: '#fa755a',
//             },
//         },
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!stripe || !elements) {
//             return;
//         }
//         const cardNumberElement = elements.getElement(CardNumberElement);
//         const cardExpiryElement = elements.getElement(CardExpiryElement);
//         const cardCvcElement = elements.getElement(CardCvcElement);
//         if (!cardNumberElement._complete) {
//             toast.error("Please enter a valid card number.");
//             return;
//         }
//         if (!cardExpiryElement._complete) {
//             toast.error("Please enter valid card's expiry date.");
//             return;
//         }
//         if (!cardCvcElement._complete) {
//             toast.error("Please enter the valid CVC (CVV) code.");
//             return;
//         }
//         setLoading(true);
//         const cardElement = elements.getElement(CardNumberElement);
//         const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
//             payment_method: {
//                 card: cardElement,
//             },
//         });
//         setLoading(false);
//         if (error) {
//             payResponse({
//                 type: "Failed",
//                 title: "Payment Failed",
//                 message: error.message
//             });
//         } else if (paymentIntent && paymentIntent.status === "succeeded") {
//             payResponse({
//                 type: "Success",
//                 title: "Payment Success",
//                 message: "Your payment is being processed and will be reflected shortly in your event. Thank you for your patience!"
//             });
//         } else {
//             payResponse({
//                 type: "Failed",
//                 title: "Payment Failed",
//                 message: "Payment Failed due to some technical error || Please try again later"
//             });
//         }
//     };

//     return (
//         <form onSubmit={handleSubmit} className={`space-y-4 p-4 ${isDarkMode ? "bg-[#1E1E1E]" : "bg-white"} shadow rounded`}>
//             <div>
//                 <label className={`block text-sm ${isDarkMode ? "text-white" : "text-gray-900"} font-medium mb-1`}>Card Number</label>
//                 <div className="border p-2 rounded">
//                     <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
//                 </div>
//             </div>
//             <div className="flex gap-4">
//                 <div className="flex-1">
//                     <label className={`block text-sm ${isDarkMode ? "text-white" : "text-gray-900"} font-medium mb-1`}>Expiry</label>
//                     <div className="border p-2 rounded">
//                         <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
//                     </div>
//                 </div>

//                 <div className="flex-1">
//                     <label className={`block text-sm ${isDarkMode ? "text-white" : "text-gray-900"} font-medium mb-1`}>CVC</label>
//                     <div className="border p-2 rounded">
//                         <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
//                     </div>
//                 </div>
//             </div>
//             <div className='text-center'>
//                 <button
//                     type="submit"
//                     disabled={!stripe || loading}
//                     className="w-[200px] bg-blue-600 text-white py-2 rounded-full hover:bg-blue-700 disabled:opacity-50">
//                     {loading ? 'Processing...' : 'Pay Now'}
//                 </button>
//             </div>
//         </form>
//     );
// };

// export default CheckoutForm;